import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import ChevronIcon from "../../../svg-icons/chevron-icon";
import "./Footer.scss";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { useSelector } from "react-redux";
import useSWR from "swr";
import LabelLang, { LabelLangString } from "component/LabelLang/label-lang";
import { END_POINTS } from "constants/APIConstant";
import HtmlView from "component/htmlView/html-view";

function Footer() {
  const [windowsScrollYPosition, setWindowsScrollYPosition] = useState(0);
  const handleScroll = (e) => {
    setWindowsScrollYPosition(window.scrollY);
  };
  useEffect(() => {
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const currentDirection = useSelector(({ theme }) => theme.direction);

  function calculateWindowWidth() {
    return window.innerWidth;
  }

  window.addEventListener("resize", calculateWindowWidth);

  const currentLocale = useSelector(({ theme }) => theme.locale);

  const contactUsFetching = useSWR({
    url: END_POINTS.FOOTER_CONTACT_US,
  });

  const socialLinkFetching = useSWR({
    url: END_POINTS.SOCIAL_LINK,
  });

  const renderSocialLink = () => {
    const linksValue =
      socialLinkFetching.error ||
      socialLinkFetching.isLoading ||
      socialLinkFetching.data === undefined ||
      socialLinkFetching.data === null
        ? ""
        : socialLinkFetching?.data?.data[0];

    // const rendering = linksValue ? JSON.parse(socialLinkFetching?.data?.data[0]?.value) : '';
    // return JSON.parse(linksValue?.value)
    return linksValue.value;
  };

  let socialLinksData = "";
  if (renderSocialLink()) {
    socialLinksData = JSON.parse(renderSocialLink());
  }

  const siteSelectionFetching = useSWR({
    url: END_POINTS.FOOTER_SITE_SELECTION,
  });

  // to render footer data
  const siteLinksRendering = () => {
    const sites =
      siteSelectionFetching.error ||
      siteSelectionFetching.isLoading ||
      siteSelectionFetching.data === undefined ||
      siteSelectionFetching.data === null
        ? []
        : siteSelectionFetching.data.data;

    const rendering = sites.map(
      ({ title, link, isInternal, siteSelectionTranslations, id }, i) => (
        <li key={i} className="col-12 col-lg-6">
          {isInternal === true ? (
            <Link to={`/${link}`}>
              <ChevronIcon width={12} height={12} color="#FFFFFF" />
              <span>
                <LabelLang
                  id={"title"}
                  defaultValue={title}
                  translations={siteSelectionTranslations}
                />{" "}
              </span>
            </Link>
          ) : (
            <a href={link} target="_blank" rel="noreferrer">
              <ChevronIcon width={12} height={12} color="#FFFFFF" />
              <span>
                <LabelLang
                  id={"title"}
                  defaultValue={title}
                  translations={siteSelectionTranslations}
                />{" "}
              </span>
            </a>
          )}
        </li>
      )
    );

    return rendering;
  };

  return (
    <footer className="Footer">
      <div className="container">
        <div className="row gy-lg-0 gy-4 justify-content-between">
          <div className="col-12 col-md-6">
            <div className="footer-t">
              <h6>
                <FormattedMessage id="selected-pages" />
              </h6>
            </div>
            <div className="row">
              <ul className="row f-links text-white">
                {
                  // siteSelectionFetching.error ||
                  siteSelectionFetching.isLoading ? (
                    <div className="text-center">
                      <h5 className="text-white" dir="ltr">
                        <FormattedMessage id="loading..." />
                      </h5>
                    </div>
                  ) : Object.keys(siteLinksRendering()).length > 0 ? (
                    siteLinksRendering()
                  ) : (
                    <FormattedMessage id="data-not-found" />
                  )
                }
              </ul>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div
              className="row special-space"
              style={{
                marginInlineStart:
                  calculateWindowWidth() >= 768 && currentDirection === "rtl"
                    ? "100px"
                    : calculateWindowWidth() >= 768 &&
                      currentDirection === "ltr"
                    ? "145px"
                    : "0",
              }}
            >
              <div className="col-12 col-lg-6">
                <div className="footer-t">
                  <h6>
                    <FormattedMessage id="contact-us" />
                  </h6>

                  <div className="list-info">
                    {/* <h6>
                      <FormattedMessage id="address" />
                    </h6>
                    <h6>
                      <FormattedMessage id="phone" />: 23456789 / 98765432
                    </h6>
                    <h6>
                      <FormattedMessage id="email" />: info@capmas.gov.eg
                    </h6> */}
                    {
                      // contactUsFetching.error ||
                      contactUsFetching.isLoading ? (
                        <div className="text-center">
                          <h5 dir="ltr">
                            <FormattedMessage id="loading..." />
                          </h5>
                        </div>
                      ) : contactUsFetching?.data?.data[0]?.value !== null &&
                        contactUsFetching?.data?.data[0]?.value !==
                          undefined ? (
                        <HtmlView
                          html={LabelLangString({
                            id: "value",
                            currentLocale: currentLocale,
                            defaultValue:
                              contactUsFetching?.data?.data[0]?.value,
                            translations:
                              contactUsFetching?.data?.data[0]
                                ?.elementTranslations,
                          })}
                        />
                      ) : (
                        <FormattedMessage id="data-not-found" />
                      )
                    }
                  </div>
                </div>
              </div>
              <div className={`col-12 col-lg-6`}>
                <div className={`footer-items`}>
                  <div className={`footer-t`}>
                    <h6>
                      <FormattedMessage id="follow-us" />
                    </h6>
                  </div>

                  <a
                    href={socialLinksData?.youtubeLink?.includes('https') ? socialLinksData?.youtubeLink : `https://${socialLinksData?.youtubeLink}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="img1"
                      src={process.env.PUBLIC_URL + "/image/youtube.svg"}
                      alt="youtube"
                      height={55}
                      width={55}
                      style={{ padding: "4px" }}
                      loading="lazy"
                    />
                  </a>
                  <a
                    href={socialLinksData?.facebookLink?.includes('https') ? socialLinksData?.facebookLink : `https://${socialLinksData?.facebookLink}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="img1"
                      src={process.env.PUBLIC_URL + "/image/facebook.svg"}
                      alt="facebook"
                      height={55}
                      width={55}
                      style={{ padding: "4px" }}
                      loading="lazy"
                    />
                  </a>
                  <br />
                  <a
                    href={socialLinksData?.twitterLink?.includes('https') ? socialLinksData?.twitterLink : `https://${socialLinksData?.twitterLink}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="img1"
                      src={process.env.PUBLIC_URL + "/image/X-logo.png"}
                      height={55}
                      width={55}
                      alt="x"
                      loading="lazy"
                    />
                  </a>
                  <a
                    href={socialLinksData?.linkedinLink?.includes('https') ? socialLinksData?.linkedinLink : `https://${socialLinksData?.linkedinLink}`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      className="img1"
                      src={process.env.PUBLIC_URL + "/image/linkedin.svg"}
                      height={55}
                      width={55}
                      style={{ padding: "4px" }}
                      alt="linkedin"
                      loading="lazy"
                    />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="boot-f">
          <div className="f-logo">
            <img
              className="img1"
              src={process.env.PUBLIC_URL + "/image/f-logo.svg"}
              alt="f-logo"
              loading="lazy"
            />
            <h6>
              <FormattedMessage id="rights" />
              <br />
              <FormattedMessage id="agency" />
              <br />
              <FormattedMessage id="republic" />
            </h6>
          </div>
        </div>
      </div>
      {windowsScrollYPosition > 0 && (
        <Button
          className="scroll-up-btn"
          onClick={() => {
            window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
          }}
          id="myBtn"
          title="Go to top"
        >
          <img
            height={35}
            width={30}
            loading="lazy"
            src={process.env.PUBLIC_URL + "/image/arrow-up.svg"}
            alt="go-to-up-svg"
          />
        </Button>
      )}
    </footer>
  );
}

export default Footer;
